/*
 * QrScanner Messages
 *
 * This contains all the text for the QrScanner component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.QrScanner';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'This is the QrScanner component!',
  },
});
